module.exports = __webpack_public_path__ + "img/3.7eda87f5.png";